import AvatarIcon from 'assets/icon/AvatarIcon'
import HomeIcon from 'assets/icon/HomeIcon'
import MenuIcon from 'assets/icon/MenuIcon'
import LogoutButton from 'components/Button/LogoutButton'
import { EmptyString } from 'utils/Constant'
import PremioLogo from '../../assets/images/LogoPremio.png'

function Navbar({ toggleSidebar }) {
	let pathArray = window.location.pathname.split("/")

	function fLogoutBtnClick(){
		localStorage.removeItem("Token")
		localStorage.removeItem("Username")
		localStorage.removeItem("FirstName")
		localStorage.removeItem("LastName")
		localStorage.removeItem("Email")

		window.location.href = "/login"
	}

   	return (
		<div className={`sticky top-0 bg-white transition-all z-20 w-full flex justify-between items-center py-2 px-4`}>
			<div className='flex items-center gap-4'>
				<button className='block' onClick={toggleSidebar}>
					<MenuIcon className='fill-black w-5' />
				</button>
				{/* <img src={PremioLogo} className='w-8 ml-4' alt='Premio Logo' /> */}
				<span className='text-lg font-semibold italic'>Padel Port</span>
			</div>
			<div className='flex gap-3 justify-between items-center'>
				<h1 className='pl-12 sm:pl-0 hidden md:block'>Welcome back, { localStorage.getItem("Name") !== null && localStorage.getItem("Name") !== EmptyString ? localStorage.getItem("Name").toUpperCase() : EmptyString }</h1>
				{/* <button className="rounded" >
					<AvatarIcon />
				</button> */}

				{/* <button className='flex items-center gap-2 bg-slate-100 px-3 py-1 rounded-sm shadow-sm' onClick={ () => { window.location.href = "/" }}>
					<HomeIcon />
					<span>Home</span>
				</button> */}
				
				<div className="relative flex items-center justify-center">
					<LogoutButton onClick={() => { fLogoutBtnClick() }} />
				</div>
			</div>
		</div>
	)
}

export default Navbar